// extracted by mini-css-extract-plugin
export default {"missionVision":"HomeMission_missionVision__DV3OP"};